import CloseIcon from "@mui/icons-material/Close";

export function PostMessage({ isOpen, onClose, handlePost }) {
	const handleClose = () => {
		onClose();
	};

	return (
		<>
			<div className={`modal-overlay ${isOpen ? "open" : ""}`}>
				{isOpen && (
					<div className="modal">
						<div className="popUp-header row">
							<div className="popUp-title">
								<h3 style={{ color: "#668fca" }}>Post Data!</h3>
							</div>
							<div className="popUp-close">
								<CloseIcon onClick={() => handleClose()} />
							</div>
						</div>
						<div
							className="popUp-body"
							style={{
								display: "flex",
								alignItems: "center",
								justifyContent: "center",
							}}
						>
							<span>Are you sure you want to post this payroll?</span>
						</div>
						<div
							className="buttons row"
							style={{
								justifyContent: "center",
								padding: "40px 40px 20px 40px",
							}}
						>
							<button
								id="add-family"
								className="save row"
								onClick={handlePost}
								style={{ marginRight: "5px" }}
							>
								POST
							</button>
							<button
								id="add-family"
								className="cancel row"
								onClick={() => handleClose()}
							>
								CANCEL
							</button>
						</div>
					</div>
				)}
			</div>
		</>
	);
}